import config from 'config';

const cdnBaseUrl = config.get('public.cdn');

export const fabrics = [
  {
    name: 'PowerHold',
    dkName: 'fabric1',
    titleMessageId: 'powerhold',
    titleDefaultMessage: 'PowerHold ®',
    compressionMessageId: 'max_compression',
    compressionDefaultMessage: 'Max Compression',
    descriptionMessageId: 'designed_for_multi_sport',
    descriptionDefaultMessage: 'Designed for Multi-sport',
    imgSrc: `https:${cdnBaseUrl}/media/images/cms_assets/assets/179858/1608579520529FL_0121_FabricGuide_FLC-7174_powerhold_lp.jpg`,
    compression: 5,
  },
  {
    name: 'Motion365',
    dkName: 'fabric5',
    titleMessageId: 'motion365',
    titleDefaultMessage: 'Motion365',
    compressionMessageId: 'high_compression',
    compressionDefaultMessage: 'High Compression',
    descriptionMessageId: 'designed_for_multi_sport',
    descriptionDefaultMessage: 'Designed for Multi-sport',
    imgSrc: `https:${cdnBaseUrl}/media/images/cms_assets/assets/179862/1608579390565FL_0121_FabricGuide_FLC-71742_M365_lp.jpg`,
    compression: 4,
  },
  {
    name: 'SculptKnit',
    dkName: 'fabric2',
    titleMessageId: 'sculptknit',
    titleDefaultMessage: 'SculptKnit',
    compressionMessageId: 'med_compression',
    compressionDefaultMessage: 'Med Compression',
    descriptionMessageId: 'designed_for_train',
    descriptionDefaultMessage: 'Designed for Train',
    imgSrc: `https:${cdnBaseUrl}/media/images/cms_assets/assets/179859/1608579559711FL_0121_FabricGuide_FLC-71743_sculptknit_lp.jpg`,
    compression: 3,
  },
  {
    name: 'PureLuxe',
    dkName: 'fabric4',
    titleMessageId: 'pureluxe',
    titleDefaultMessage: 'PureLuxe',
    compressionMessageId: 'med_light_compression',
    compressionDefaultMessage: 'Med-Light Compression',
    descriptionMessageId: 'designed_for_studio',
    descriptionDefaultMessage: 'Designed for Studio',
    imgSrc: `https:${cdnBaseUrl}/media/images/cms_assets/assets/179861/1608579369815FL_0121_FabricGuide_FLC-71744_ultracool_lp.jpg`,
    compression: 2,
  },
  {
    name: 'Seamless',
    dkName: 'fabric3',
    titleMessageId: 'seamless',
    titleDefaultMessage: 'Seamless',
    compressionMessageId: 'light_compression',
    compressionDefaultMessage: 'Light Compression',
    descriptionMessageId: 'designed_for_studio',
    descriptionDefaultMessage: 'Designed for Studio',
    imgSrc: `https:${cdnBaseUrl}/media/images/cms_assets/assets/179860/1608579322754FL_0121_FabricGuide_FLC-71745_seamless_lp.jpg`,
    compression: 1,
  },
];
